<template lang="html">
  <b-field>
    <template slot="label">
      {{ wordPosition }} Word
      <b-tooltip
        position="is-right"
        type="is-dark"
        multilined
        size="is-small"
        label="Small introduction speech"
      >
        <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
      </b-tooltip>
    </template>
    <!-- Craft  -->
    <span v-if="itemType == 'craft'">
      <!-- Starting Word -->
      <b-input
        v-if="wordPosition == 'Starting'"
        placeholder="e.g. Take a cup of matcha and enjoy!"
        v-model="localWord"
        maxlength="100"
        @input="updateWord"
      />
      <!-- Ending Word -->
      <b-input
        v-else
        placeholder="e.g. You did it! Go take a well-deserved rest!"
        v-model="localWord"
        maxlength="100"
        @input="updateWord"
      />
    </span>

    <!-- Article  -->
    <span v-else-if="itemType == 'article'">
      <!-- Starting Word -->
      <b-input
        v-if="wordPosition == 'Starting'"
        placeholder="e.g. Take a cup of matcha and enjoy!"
        v-model="localWord"
        maxlength="100"
        @input="updateWord"
      />
      <!-- Ending Word -->
      <b-input
        v-else
        placeholder="e.g. I hope you enjoyed the Article!"
        v-model="localWord"
        maxlength="100"
        @input="updateWord"
      />
    </span>

    <span v-else>
      <!-- Starting Word -->
      <b-input v-model="localWord" maxlength="100" @input="updateWord" />
    </span>
  </b-field>
</template>

<script>
export default {
  props: ['word', 'wordPosition', 'itemType'],
  data () {
    return {
      localWord: null
    }
  },
  created () {
    this.localWord = this.word
  },
  methods: {
    updateWord (value) {
      this.$emit('updateWord', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
